module.exports = __webpack_public_path__ + "static/media/icons-navigation-down.a710cc08.svg";